//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";

//css
import styled from "styled-components";
// component
import StateBox from "../../../../component/content/StateBox";
import ProductInfo from "../../../../component/content/ProductInfo";
import UserInfo from "../../../../component/content/UserInfo";
import PaymentInfo from "../../../../component/content/PaymentInfo";
import AddressInfo from "../../../../component/content/AddressInfo";

// img
import more from "../../../../assets/img/icon/icon_more2.svg";
import product from "../../../../assets/img/picture/product.jpg";

// testData
import { OrderListData } from "../../../../Data";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyOrderDetail(props) {
    let { id } = useParams();
    let selectItem = OrderListData.find(function (item) {
        return item.id == id;
    });

    return (
        <Wrap>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>주문상세내역</MyPageTitle>
            </MyPageTitleBox>

            <OrderTableWrap>
                {/* 테이블 제목 */}
                <TabelTitle>
                    <TabelText>
                        <span>주문일자</span> {selectItem.date}
                    </TabelText>
                    <TabelText>
                        <span>주문번호</span> {selectItem.ordernum}
                        <MoreBtn>
                            <img src={more} alt="아이콘" />
                        </MoreBtn>
                    </TabelText>
                </TabelTitle>

                {/* 주문상세내역 */}
                <StateBoxWrap>
                    <StateBox />
                </StateBoxWrap>
            </OrderTableWrap>

            {/* 주문상품정보 */}
            <Article>
                <ProductInfo orderlistData={selectItem.orderlist} />
            </Article>

            <Article>
                {/* 구매자 정보 */}
                <UserInfo />
            </Article>

            <Article>
                {/* 결제 정보 */}
                <PaymentInfo />
            </Article>

            {/* 배송지 정보 */}
            <Article>
                <AddressInfo />
            </Article>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;
const Article = styled.article`
    &:not(:first-child) {
        margin-top: calc(100vw * (50 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (50 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(30)};
        }
    }
`;
const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const OrderTableWrap = styled.div`
    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;
const TabelTitle = styled.ul`
    display: flex;
    align-items: baseline;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;

    & p:first-child {
        margin-right: calc(100vw * (40 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & p:first-child {
            margin-right: calc(100vw * (40 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        justify-content: space-between;
        padding: ${M(15)} 0;

        & p:first-child {
            margin-right: ${M(20)};
        }
    }
`;

const StateBoxWrap = styled.div`
    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(30)};
    }
`;
const TabelText = styled.p`
    display: flex;
    align-items: center;

    font-size: calc(100vw * (15 / 1920));

    & span {
        font-family: "Noto-R";
        margin-right: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        & span {
            margin-right: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        & span {
            display: none;
        }
    }
`;

const MoreBtn = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (5 / 1920));
    height: calc(100vw * (10 / 1920));

    margin-left: calc(100vw * (10 / 1920));

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (5 / 1300));
        height: calc(100vw * (10 / 1300));
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(5)};
        height: ${M(10)};
        margin-left: ${M(10)};
    }
`;
